export const COMPETITIONS_SLIDER_WIDGET = {
  SCREEN_RESOLUTIONS: {
    sm: 1366,
    xs: 1024,
    xxs: 768
  },
  DEVICES: {
    mobile: 'mobile',
    tablet: 'tablet',
    desktop: 'desktop',
    largeDesktop: 'large-desktop',
  },
  ITEM_WIDTH: {
    lg: 345,
    sm: 192
  },
  ACTION_TYPES: {
    competitionChange: 'competitionChange',
    populateDataHandler: 'populateDataHandler',
    populateCompetitionsDataHandler: 'populateCompetitionsDataHandler',
    fetchGames: 'fetchGames',
    displayEvent: 'displayEvent'
  },
  DEFAULT_COMPETITION_TOP_GAMES_ID: -1
}
